import axios from "axios";
import { baseUrl } from "../Utility/ServicesConstant";

const instance = axios.create({
  baseURL: baseUrl,
});

export default instance;
